const UserRoleEnum = Object.freeze({
    SUPERADMIN: 'super-admin',
    ADMIN: 'admin',
    PARTNER: 'partner',
    TOURNAMENTMANAGER: 'tournament-manager',
    STAFF: 'staff',
    STANDARDUSER: 'standard-user',
    TICKETINGADMIN: 'ticketing-manager',
    ACTIVATIONADMIN: 'activation-admin',
    CHECKINOPERATOR: 'check-in-operator'
});

export default UserRoleEnum;
